import logoC6 from '../assets/img/c6bank.svg';
import logoCrefaz from '../assets/img/crefaz.svg';
import logoSoma from '../assets/img/soma.svg';
import logoFacta from '../assets/img/facta-financeira.svg';
import logoPresenca from '../assets/img/presenca-bank.svg';
import logoBmg from '../assets/img/banco-bmg.svg';
import logoVctex from '../assets/img/vctex.svg'
import logoDaycoval from '../assets/img/banco-daycoval.svg'
import logoIcred from '../assets/img/icred.svg';
import logoTotalcash from '../assets/img/totalcash.svg'

import logoC6Mobile from '../assets/img/c6Mobile.svg';
import logoCrefazMobile from '../assets/img/crefazMobile.svg';
import logoSomaMobile from '../assets/img/somaMobile.svg';
import logoFactaMobile from '../assets/img/factaMobile.svg';
import logoPresencaMobile from '../assets/img/Presença_Bank_mobile.svg';
import logoVctexMobile from '../assets/img/vctexMobile.svg'
import logoBmgMobile from '../assets/img/bmgMobile.svg'
const LOGO_MAP: Record<string, string> = {
    C6_BANK: logoC6,
    CREFAZ: logoCrefaz,
    SOMA_CELCOIN: logoSoma,
    SOMA_UY3: logoSoma,
    FACTA: logoFacta,
    PRESENCA: logoPresenca,
    BMG: logoBmg,
    VCTEX: logoVctex,
    DAYCOVAL: logoDaycoval,
    TOTALCASH: logoTotalcash,
    ICRED: logoIcred,
};

const LOGO_MAP_MOBILE: Record<string, string> = {
    C6_BANK: logoC6Mobile,
    CREFAZ: logoCrefazMobile,
    SOMA_CELCOIN: logoSomaMobile,
    SOMA_UY3: logoSomaMobile,
    FACTA: logoFactaMobile,
    PRESENCA: logoPresencaMobile,
    BMG: logoBmgMobile,
    VCTEX: logoVctexMobile,
    DAYCOVAL: logoDaycoval,
    TOTALCASH: logoTotalcash,
};

export function getFinanceiraLogo(canonicalId?: string | null): string {
    if (!canonicalId) return '';
    return LOGO_MAP[canonicalId.toUpperCase()] ?? '';
}

export function getFinanceiraLogoMobile(canonicalId?: string | null): string {
    if (!canonicalId) return '';
    return LOGO_MAP_MOBILE[canonicalId.toUpperCase()] ?? '';
}
